<dashboardnav>

  
  <mrsoftapps-documents [OriginatingModule]="OriginatingModule" [OriginatedModuleSpecificId]="OriginatedModuleSpecificId">

  </mrsoftapps-documents>

</dashboardnav>
